import React, { useRef, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import {
  generateAdmissionNo,
  getCourseDuration,
  getSalutation,
} from "./utils/letterUtils";

export default function BonafideLetter({ student }) {
  const printRef = useRef();

  const { salute, title, possessive, pronoun, hostel } =
    getSalutation(student?.gender);

  const [formData, setFormData] = useState({
    refNo: generateAdmissionNo({
      prefix: "RBT",
      course: student?.selectedCourse,
      studentId: student?.studentId,
    }),

    date: new Date().toLocaleDateString("en-IN"),

    studentName:
      [student?.firstName, student?.middleName, student?.lastName]
        .filter(Boolean)
        .join(" ") || "",

    parentName: student?.fatherName || "",
    address: student?.homeAddress || "",

    course: student?.selectedCourse || "",
    academicYear: student?.academicYear || "",

    duration: getCourseDuration(
      student?.selectedCourse || "",
      student?.academicYear || ""
    ),

    admissionNo: student?.studentId || "",

    university: "Rajiv Gandhi University of Health Sciences",
    recognition:
      "KNC Govt. of Karnataka & Indian Nursing Council, New Delhi",

    instituteName: "REHOBOTH INSTITUTE OF NURSING",
    approvalLine:
      "(Recognized by Govt. of Karnataka & Indian Nursing Council)",
    addressLine: "Bangalore, Karnataka",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const win = window.open("", "", "width=900,height=700");

    win.document.write(`
      <html>
        <head>
          <title>Bonafide Certificate</title>
          <style>
            body {
              font-family: "Times New Roman", serif;
              padding: 120px 40px;
              line-height: 1.8;
            }
            .center { text-align: center; }
            .right { text-align: right; }
          </style>
        </head>
        <body>${content}</body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  return (
    <Container className="mt-4">
      {/* FORM */}
      <Form className="mb-4">
        <Row className="mb-2">
          <Col><Form.Control name="refNo" value={formData.refNo} onChange={handleChange} /></Col>
          <Col><Form.Control name="date" value={formData.date} onChange={handleChange} /></Col>
        </Row>

        <Row className="mb-2">
          <Col><Form.Control name="studentName" value={formData.studentName} onChange={handleChange} /></Col>
          <Col><Form.Control name="parentName" value={formData.parentName} onChange={handleChange} /></Col>
        </Row>

        <Row className="mb-2">
          <Col><Form.Control name="course" value={formData.course} onChange={handleChange} /></Col>
          <Col><Form.Control name="academicYear" value={formData.academicYear} onChange={handleChange} /></Col>
        </Row>

        <Row className="mb-2">
          <Col><Form.Control name="duration" value={formData.duration} onChange={handleChange} /></Col>
          <Col><Form.Control name="admissionNo" value={formData.admissionNo} onChange={handleChange} /></Col>
        </Row>
      </Form>

      <div className="text-end mb-3">
        <Button onClick={handlePrint}>Print</Button>
      </div>

      {/* LETTER */}
      <div ref={printRef} style={{ padding: 25, border: "1px solid #000" }}>
        
        {/* HEADER */}
      
<div style={{marginTop:"160px"}}>
        {/* REF + DATE */}
        <Row className="mt-3">
          <Col><strong>{formData.refNo}</strong></Col>
          <Col className="right"><strong>{formData.date}</strong></Col>
        </Row>

        {/* TITLE */}
        <Row className="mt-4">
          <Col className="center">
            <h4><u>BONAFIDE CERTIFICATE</u></h4>
          </Col>
        </Row>

        {/* BODY */}
        <div className="mt-4">
          <p>
            This is to certify that <strong>{salute} {formData.studentName}</strong>,{" "}
            {title} Mr. <strong>{formData.parentName}</strong>, residing at{" "}
            <strong>{formData.address}</strong>, is a bonafide student of our
            institution in <strong>{formData.course}</strong> from the academic year{" "}
            <strong>{formData.academicYear}</strong>.
          </p>

          <p>
            The duration of the course is <strong>{formData.duration}</strong>.{" "}
            {possessive} Admission No. is <strong>{formData.admissionNo}</strong>.
          </p>

          <p>
            {salute} {formData.studentName} is currently in the 1st year and{" "}
            {pronoun} stays in the <strong>{hostel}</strong> of our college.
          </p>

          <p>
            This institution is affiliated to <strong>{formData.university}</strong>{" "}
            and recognized by <strong>{formData.recognition}</strong>.
          </p>
        </div>

        {/* FOOTER */}
        <Row className="mt-5" style={{ paddingTop: "40px" }}>
          <Col className="text-end">
            <strong>Principal</strong>
          </Col>
        </Row>

      </div>
      </div>
    </Container>
  );
}